import initialState from './serviceTitanInitialState';
import mutations from './serviceTitanMutation';
import actions from './serviceTitanAction';

const getters = {};
const customerDetailModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default customerDetailModule;
